import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as planAction from "../redux/plan/planAction";
import brand_logo from "../assets/svg/brand_logo.svg";
import "./success.css";

const Success = () => {
  const { selectedPlan, isTrial } = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const planName = state?.planName || "Subscription Plan";
  const planPrice = state?.planPrice || 0;
  const currency = state?.currency || "£";
  const discountAmount = state?.discountAmount || 0;
  const discountLabel = state?.discountLabel || "";
  const totalPrice = state?.totalPrice || 0;
  const paymentIntentId = state?.paymentIntentId || selectedPlan || "";

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  useEffect(() => {
    dispatch(planAction.setPlanExpiry({ selectedPlan, paymentIntentId, isTrial }));
  }, [selectedPlan]);

  return (
    <div className="success-wrapper">
      <div className="success-card">
        {/* Header with gradient */}
        <div className="success-header">
          <img
            src={brand_logo}
            alt="AceMe6 Logo"
            className="success-logo"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
          <div className="success-check-circle">
            <span className="success-check-icon">✓</span>
          </div>
          <h1 className="success-title">Payment Successful!</h1>
          <p className="success-subtitle">
            Thank you for your purchase. Your subscription is now
            active.
          </p>
        </div>

        {/* Body with plan details */}
        <div className="success-body">
          <span className="success-plan-badge">Order Summary</span>

          {/* Plan row */}
          <div className="success-detail-row">
            <span className="success-detail-label">
              {planName}
            </span>
            <span className="success-detail-value">
              {currency}
              {Number(planPrice).toFixed(2)}
            </span>
          </div>

          {/* Discount row */}
          {discountAmount > 0 && (
            <>
              <hr className="success-divider" />
              <div className="success-detail-row discount">
                <span className="success-detail-label">
                  {discountLabel}
                </span>
                <span className="success-detail-value">
                  -{currency}
                  {Number(discountAmount).toFixed(2)}
                </span>
              </div>
            </>
          )}

          {/* Total */}
          <hr className="success-divider" />
          <div className="success-total-row">
            <span className="success-total-label">
              Amount Paid
            </span>
            <span className="success-total-value">
              {currency}
              {Number(totalPrice).toFixed(2)}
            </span>
          </div>

          {/* Payment ID */}
          {paymentIntentId && (
            <div className="success-payment-id">
              <span className="success-payment-id-label">
                Payment ID
              </span>
              <span className="success-payment-id-value">
                {paymentIntentId}
              </span>
            </div>
          )}

          {/* Date */}
          <p className="success-date">
            Payment Date: {currentDate}
          </p>

          {/* Action Buttons */}
          <div className="success-actions">
            <a href="/" className="success-btn-primary">
              Start Learning →
            </a>
            <a href="/account" className="success-btn-secondary">
              View My Account
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
